import { getLocale } from '@/domains/core/settings/utils';

function addCurrency(formattedNumber: string) {
  if (getLocale() === 'en-GB') return `£${formattedNumber}`;
  return `${formattedNumber}€`;
}

/**
 * Format number into percentage for each country
 * Ex w/2fractionDigits: 67.89
 * Ex w/1fractionDigits: 67.8
 * Ex wo/fractionDigits: 67 // 67.00
 * Ex w/thousands: 4567.89
 *
 *  DE -> 67,89%
 *  DE -> 67,8%
 *  DE -> 67%
 *  DE -> 4.567,89%
 *
 *  FR -> 67,89%
 *  FR -> 67,8%
 *  FR -> 67%
 *  FR -> 4 567,89%
 *
 *  ES -> 67,89%
 *  ES -> 67,8%
 *  ES -> 67%
 *  ES -> 4567,89%
 *
 *  IT -> 67,89%
 *  IT -> 67,8%
 *  IT -> 67%
 *  IT -> 4.567,89%
 *
 *  UK -> 67.89%
 *  UK -> 67.8%
 *  UK -> 67%
 *  UK -> 4,567.89%
 */
export const formatPercentageNarrowedByLocale = (number: number) => {
  const formattedPercentage = (number / 100).toLocaleString(getLocale(), {
    style: 'percent',
    maximumFractionDigits: 2,
  });

  // Always narrow percentage unit symbol
  return formattedPercentage.replace(/\s%/, '%');
};

/**
 * Format number into price for each country without decimals
 * Ex: 1234567.89
 *
 *  DE -> 1.234.567€
 *
 *  FR -> 1 234 567€
 *
 *  ES -> 1.234.567€
 *
 *  IT -> 1.234.567€
 *
 *  UK -> £1.234.567
 */
export const formatPriceCompactByLocale = (number: number) => {
  const formattedPrice = number.toLocaleString(getLocale(), {
    minimumFractionDigits: Math.ceil(number % 1) * 2,
    maximumFractionDigits: 2,
  });

  // Formmater formats number with 123,00 €
  // But we want to remove the space so it becomes 123,00€
  return addCurrency(formattedPrice);
};
